<template>
  <div>
    <div class="cart market-view">
      <div class="cart_container">
        <div class="cart_header" :class="{ 'cart_header--closed': !cartOpen }" @click="onHeaderClick">
          <div class="cart-tabs" @click.stop>
            <div class="item" :class="cartSection == 'bet' ? 'active' : 'deactivated'" @click="switchCartSection('bet')">
              <span class="tab-label">{{$t('bet')}}</span>
              <span class="tab-badge" v-if="effectiveOddsCount > 0">{{effectiveOddsCount}}</span>
            </div>
          </div>


        </div>
        <transition name="cart-collapse">
          <div v-show="cartOpen">
            <div class="cart-content" v-if="cartSection == 'bet'">
              <BetSlipTerminal></BetSlipTerminal>
            </div>
          </div>


        </transition>
        <ActionsCartTerminal v-if="!getConfirmedBet && !hasAcceptanceBets && cartSection == 'bet'" :showBookButton="false"></ActionsCartTerminal>

      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import MyBets from "@/components/right_widgets/MyBets";
import BetSlipTerminal from "@/components/terminal/BetSlipTerminal";
import { isMobileOnly } from 'mobile-device-detect';
import ActionsCartTerminal from "@/components/terminal/ActionsCartTerminal.vue";
import { postToParent, PARENT_EVENTS } from "@/services/parentBridge/parentBridge";

export default {
  name: 'CartMarketView',
  components: {ActionsCartTerminal, MyBets, BetSlipTerminal},
  data: () => ({
    cartSection: "bet",
    other : 'item cart-button',
    // Always open at start, not remembered: a terminal is shared, the state one player leaves
    // must not carry over to the next one (the classic layout remembers it)
    cartOpen: true,
  }),
  computed: {
    ...mapGetters({
      'getLanguage': 'settings/getLanguage',
      'getBet': 'cart/getBet',
      'getLoading': 'cart/getLoading',
      'getMobileCartOpen': 'cart/getMobileCartOpen',
      'getConfirmedBet':          'cart/getConfirmedBet',
      'getAcceptingBets':         'cart/getAcceptingBets',
      'getAcceptedBetWithChange': 'cart/getAcceptedBetWithChange',
    }),
    hasAcceptanceBets() {
      return (this.getAcceptingBets || []).length > 0 || (this.getAcceptedBetWithChange || []).length > 0;
    },
    effectiveOddsCount() {
      const odds = this.getBet.odds;
      const bbIds = new Set(odds.filter(o => o.bet_builder_id).map(o => o.bet_builder_id));
      return odds.filter(o => !o.bet_builder_id).length + bbIds.size;
    },
    getCashoutLive(){ //todo cambiare e aggiungere la  mapgetters quando siamo pronti
      return false
    },
    getCashout(){ //todo cambiare e aggiungere la  mapgetters quando siamo pronti
      return false
    }

  },
  methods: {
    ...mapActions({
      'setLoadingCart': 'cart/setLoadingCart',
    }),

    onHeaderClick() {
      if (isMobileOnly) {
        this.$root.$emit('close_sidebar_right', true);
      } else {
        this.cartOpen = !this.cartOpen;
        // Parent bridge: the mobile cart is posted by the store plugin, the desktop one from here.
        postToParent(PARENT_EVENTS.CART_STATE_CHANGED, { isOpen: this.cartOpen });
      }
    },

    switchCartSection(section){
      this.cartSection = section;
      this.$root.$emit('cart-section-change', section);
    },

  },

  mounted() {
    // Kept to remove exactly this handler: other components listen to sectionCart too
    this._onSectionCart = () => this.switchCartSection('bet');
    this.$root.$on('sectionCart', this._onSectionCart);
  },

  beforeDestroy() {
    this.$root.$off('sectionCart', this._onSectionCart);
  },

};
</script>

<style scoped>
/* ── Card shell ──────────────────────────────────────────── */
.v-card.cart.market-view {
    background-color: var(--bg-header);
    border-radius: 0px;
    box-shadow: none !important;
    overflow: hidden;
}

/* ── Tabs inside header ──────────────────────────────────── */
.cart-tabs {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 6px;
  gap: 6px;
}

.cart-tabs .item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  font-size: var(--font-size-xl);
  border-radius: 5px;
  font-weight: 500;
  cursor: pointer;
  color: var(--text-op-50-platform);
  transition: background 0.15s, color 0.15s;
  user-select: none;
  white-space: nowrap;
  padding: 12px 0 12px 12px;
}

.cart-tabs .item.active {
  color: var(--text-platform);
  font-weight: bolder;
}

.cart-tabs .item--hidden {
  opacity: 0.3;
  cursor: default;
  pointer-events: none;
  display: none;
}



/* ── Tab label ───────────────────────────────────────────── */
.tab-label {
    line-height: 1;
}

/* ── Badge numero quote ──────────────────────────────────── */
.tab-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: var(--color-primary-light);
    color: var(--bg-body);
    font-size: var(--font-size-xs);
    font-weight: 700;
    border-radius: 9px;
    min-width: 16px;
    height: 16px;
    padding: 0 4px;
    line-height: 1;
}

/* ── Content wrapper ─────────────────────────────────────── */
.cart-content {
  background: var(--sidebar);
  border-radius: 0 0 8px 8px;
}

.cart_container{

}
.cart_container .cart_header{
  background: var(--bg-card);
  border-radius: 8px 8px 0 0;
  padding: 0;
  font-size: var(--font-size-4xl);
  font-weight: 700;
  line-height: 15px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  user-select: none;
}

.cart_header--closed {
  border-radius: 8px !important;
}

.cart-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--color-primary-light);
  color: var(--bg-body);
  font-size: var(--font-size-xl);
  font-weight: 700;
  border-radius: 50%;
  min-width: 22px;
  height: 22px;
  padding: 0 5px;
  line-height: 1;
}

/* Collapse transition */
.cart-collapse-enter-active,
.cart-collapse-leave-active {
  transition: max-height 0.3s ease, opacity 0.25s ease;
  overflow: hidden;
  max-height: 2000px;
}

.cart-collapse-enter,
.cart-collapse-leave-to {
  max-height: 0;
  opacity: 0;
}
.cart_container .cart-content {
  padding: 4px  ;

}

.cart.market-view{
  display: flex;
  flex-direction: column;
  gap: 20px;
}

</style>